<div class="container-fluid">
  <div class="header">
    <h2>Cadastro de Assessor</h2>
  </div>

  <div class="form-container">
    <form [formGroup]="formAssessor" (ngSubmit)="onSubmit()" class="assessor-form">
      
      <!-- Dados Pessoais -->
      <div class="form-section">
        <h4>Dados Pessoais</h4>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="nome">Nome Completo:</label>
              <input 
                type="text" 
                id="nome" 
                formControlName="nome" 
                class="form-control"
                [class.is-invalid]="isFieldInvalid('nome')"
                placeholder="Digite o nome completo">
              <small class="text-danger" *ngIf="isFieldInvalid('nome')">
                {{ getFieldError('nome') }}
              </small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="dataNascimento">Data de Nascimento:</label>
              <input 
                type="date" 
                id="dataNascimento" 
                formControlName="dataNascimento" 
                class="form-control"
                [class.is-invalid]="isFieldInvalid('dataNascimento')">
              <small class="text-danger" *ngIf="isFieldInvalid('dataNascimento')">
                {{ getFieldError('dataNascimento') }}
              </small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="cpf">CPF:</label>
              <input 
                type="text" 
                id="cpf" 
                formControlName="cpf" 
                class="form-control"
                [class.is-invalid]="isFieldInvalid('cpf')"
                placeholder="000.000.000-00">
              <small class="text-danger" *ngIf="isFieldInvalid('cpf')">
                {{ getFieldError('cpf') }}
              </small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="rg">RG:</label>
              <input 
                type="text" 
                id="rg" 
                formControlName="rg" 
                class="form-control"
                [class.is-invalid]="isFieldInvalid('rg')"
                placeholder="Digite o RG">
              <small class="text-danger" *ngIf="isFieldInvalid('rg')">
                {{ getFieldError('rg') }}
              </small>
            </div>
          </div>
        </div>
      </div>

      <!-- Dados de Acesso -->
      <div class="form-section">
        <h4>Dados de Acesso</h4>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="email">Email/Login:</label>
              <input 
                type="email" 
                id="email" 
                formControlName="email" 
                class="form-control"
                [class.is-invalid]="isFieldInvalid('email')"
                placeholder="email@exemplo.com">
              <small class="text-danger" *ngIf="isFieldInvalid('email')">
                {{ getFieldError('email') }}
              </small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="confirmacaoEmail">Confirmação Email/Login:</label>
              <input 
                type="email" 
                id="confirmacaoEmail" 
                formControlName="confirmacaoEmail" 
                class="form-control"
                [class.is-invalid]="isFieldInvalid('confirmacaoEmail')"
                placeholder="Confirme o email">
              <small class="text-danger" *ngIf="isFieldInvalid('confirmacaoEmail')">
                {{ getFieldError('confirmacaoEmail') }}
              </small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="senha">Senha:</label>
              <input 
                type="password" 
                id="senha" 
                formControlName="senha" 
                class="form-control"
                [class.is-invalid]="isFieldInvalid('senha')"
                placeholder="Digite a senha">
              <small class="text-danger" *ngIf="isFieldInvalid('senha')">
                {{ getFieldError('senha') }}
              </small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="confirmacaoSenha">Confirmação de Senha:</label>
              <input 
                type="password" 
                id="confirmacaoSenha" 
                formControlName="confirmacaoSenha" 
                class="form-control"
                [class.is-invalid]="isFieldInvalid('confirmacaoSenha')"
                placeholder="Confirme a senha">
              <small class="text-danger" *ngIf="isFieldInvalid('confirmacaoSenha')">
                {{ getFieldError('confirmacaoSenha') }}
              </small>
            </div>
          </div>
        </div>
      </div>

      <!-- Endereço -->
      <div class="form-section">
        <h4>Endereço</h4>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="cep">CEP:</label>
              <input 
                type="text" 
                id="cep" 
                formControlName="cep" 
                class="form-control"
                [class.is-invalid]="isFieldInvalid('cep')"
                placeholder="00000-000">
              <small class="text-danger" *ngIf="isFieldInvalid('cep')">
                {{ getFieldError('cep') }}
              </small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="rua">Rua:</label>
              <input 
                type="text" 
                id="rua" 
                formControlName="rua" 
                class="form-control"
                [class.is-invalid]="isFieldInvalid('rua')"
                placeholder="Digite a rua">
              <small class="text-danger" *ngIf="isFieldInvalid('rua')">
                {{ getFieldError('rua') }}
              </small>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="numero">Número:</label>
              <input 
                type="text" 
                id="numero" 
                formControlName="numero" 
                class="form-control"
                [class.is-invalid]="isFieldInvalid('numero')"
                placeholder="Número">
              <small class="text-danger" *ngIf="isFieldInvalid('numero')">
                {{ getFieldError('numero') }}
              </small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label for="bairro">Bairro:</label>
              <input 
                type="text" 
                id="bairro" 
                formControlName="bairro" 
                class="form-control"
                [class.is-invalid]="isFieldInvalid('bairro')"
                placeholder="Digite o bairro">
              <small class="text-danger" *ngIf="isFieldInvalid('bairro')">
                {{ getFieldError('bairro') }}
              </small>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="complemento">Complemento:</label>
              <input 
                type="text" 
                id="complemento" 
                formControlName="complemento" 
                class="form-control"
                placeholder="Apartamento, bloco, etc.">
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="pais">País:</label>
              <select 
                id="pais" 
                formControlName="pais" 
                class="form-control"
                [class.is-invalid]="isFieldInvalid('pais')">
                <option value="">Selecione o país</option>
                <option value="Brasil">Brasil</option>
                <option value="Itália">Itália</option>
                <option value="Estados Unidos">Estados Unidos</option>
                <option value="Argentina">Argentina</option>
                <option value="Uruguai">Uruguai</option>
                <option value="Outros">Outros</option>
              </select>
              <small class="text-danger" *ngIf="isFieldInvalid('pais')">
                {{ getFieldError('pais') }}
              </small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="estado">Estado:</label>
              <select 
                id="estado" 
                formControlName="estado" 
                class="form-control"
                [class.is-invalid]="isFieldInvalid('estado')">
                <option value="">Selecione o estado</option>
                <option value="SP">São Paulo</option>
                <option value="RJ">Rio de Janeiro</option>
                <option value="MG">Minas Gerais</option>
                <option value="RS">Rio Grande do Sul</option>
                <option value="PR">Paraná</option>
                <option value="SC">Santa Catarina</option>
                <option value="BA">Bahia</option>
                <option value="PE">Pernambuco</option>
                <option value="CE">Ceará</option>
                <option value="GO">Goiás</option>
                <option value="PA">Pará</option>
                <option value="MA">Maranhão</option>
                <option value="ES">Espírito Santo</option>
                <option value="PB">Paraíba</option>
                <option value="RN">Rio Grande do Norte</option>
                <option value="AL">Alagoas</option>
                <option value="PI">Piauí</option>
                <option value="MT">Mato Grosso</option>
                <option value="MS">Mato Grosso do Sul</option>
                <option value="TO">Tocantins</option>
                <option value="RO">Rondônia</option>
                <option value="AC">Acre</option>
                <option value="AM">Amazonas</option>
                <option value="RR">Roraima</option>
                <option value="AP">Amapá</option>
                <option value="SE">Sergipe</option>
                <option value="DF">Distrito Federal</option>
              </select>
              <small class="text-danger" *ngIf="isFieldInvalid('estado')">
                {{ getFieldError('estado') }}
              </small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="cidade">Cidade:</label>
              <input 
                type="text" 
                id="cidade" 
                formControlName="cidade" 
                class="form-control"
                [class.is-invalid]="isFieldInvalid('cidade')"
                placeholder="Digite a cidade">
              <small class="text-danger" *ngIf="isFieldInvalid('cidade')">
                {{ getFieldError('cidade') }}
              </small>
            </div>
          </div>
        </div>
      </div>

      <!-- Contato -->
      <div class="form-section">
        <h4>Contato</h4>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="telefoneCelular">Telefone Celular:</label>
              <input 
                type="text" 
                id="telefoneCelular" 
                formControlName="telefoneCelular" 
                class="form-control"
                [class.is-invalid]="isFieldInvalid('telefoneCelular')"
                placeholder="(00) 00000-0000">
              <small class="text-danger" *ngIf="isFieldInvalid('telefoneCelular')">
                {{ getFieldError('telefoneCelular') }}
              </small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="telefoneAdicional">Telefone Adicional:</label>
              <input 
                type="text" 
                id="telefoneAdicional" 
                formControlName="telefoneAdicional" 
                class="form-control"
                placeholder="(00) 0000-0000">
            </div>
          </div>
        </div>
      </div>

      <!-- Observações -->
      <div class="form-section">
        <h4>Observações</h4>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="observacoes">Observações:</label>
              <textarea 
                id="observacoes" 
                formControlName="observacoes" 
                class="form-control"
                rows="4"
                placeholder="Digite observações adicionais..."></textarea>
            </div>
          </div>
        </div>
      </div>

      <!-- Botões de Ação -->
      <div class="form-actions">
        <button type="button" class="btn btn-secondary" (click)="limparFormulario()">Limpar</button>
        <button type="submit" class="btn btn-primary ms-2" [disabled]="!formAssessor.valid">Salvar Assessor</button>
      </div>
    </form>
  </div>
</div> 